import { apiCall } from './gqlClient';

const GETEQUIPMENTS_QUERY = `
  query getEquipments {
    getEquipments
    {
      id
			name
			type
      ...fragments
    }
  }`;

export const getEquipmentsApiCall = async (fragments = null) => apiCall({ query: GETEQUIPMENTS_QUERY, variables: {}, fragments });
